import * as React from "react";
import { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { toast } from "react-toastify";
import ActivityTagsList from "./ActivityTagsList";
import EditActivityTag from "./EditActivityTag";
import { addActivityTag } from "services/activityTagService";
import { useActiveDepartments } from "services/departmentService";
import { useActiveWorkTypes } from "services/workTypeService";
import styles from "../Settings.module.scss";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { FiAlertCircle } from "react-icons/fi";

const ActivityTags = (props) => {
  const [addnewform, setAddnewform] = useState(false);
  const [departmentID, setDepartmentID] = useState(0);
  const [workType, setWorkType] = useState(null);

  const { data: departments, loading: loadingDepartments } =
    useActiveDepartments();
  const { data: workTypes, loading: loadingWorkTypes } = useActiveWorkTypes();

  const formattedDepartments = React.useMemo(() => {
    if (!departments) return [{ name: "ALL", departmentID: 0 }];
    return [{ name: "ALL", departmentID: 0 }, ...departments];
  }, [departments]);

  const workTypeOptions = React.useMemo(() => {
    if (!departmentID) return [];
    return (workTypes || []).filter((wt) =>
      String(wt.departmentId) === String(departmentID),
    );
  }, [departmentID, workTypes]);

  React.useEffect(() => {
    if (props.onClose === false) {
      setAddnewform(false);
    }
  }, [props.onClose]);

  const closeform = () => {
    setAddnewform(false);
  };

  const handleSubmit = async (data) => {
    try {
      await addActivityTag(data);
      toast.success("Activity Tag Added Successfully");
    } catch {
    } finally {
      setAddnewform(false);
    }
  };

  const onDepartmentChange = (e) => {
    setDepartmentID(e?.value?.departmentID || 0);
    setWorkType(null);
  };

  const onWorkTypeChange = (e) => {
    setWorkType(e.value || null);
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className={"d-flex mb-3 justify-content-between align-items-center"}>
        <div className="d-flex gap-3 align-items-center flex-wrap">
          <div className=" d-flex flex-column">
            <Label>Department</Label>
            <ComboBox
              data={formattedDepartments}
              className={`${styles["work-type-field-style"]} mt-1`}
              iconClassName="wa"
              textField="name"
              dataItemKey="departmentID"
              placeholder="Select Department"
              value={
                formattedDepartments.find(
                  (d) => d.departmentID === departmentID,
                ) || { name: "ALL", departmentID: 0 }
              }
              onChange={onDepartmentChange}
              style={{ width: "230px" }}
              disabled={loadingDepartments}
              loading={loadingDepartments}
            />
          </div>

          <div className="d-flex align-items-center gap-2">

            <div className="d-flex flex-column">
              <Label>Work Type</Label>
              <ComboBox
                data={workTypeOptions}
                className={`${styles["work-type-field-style"]} mt-1`}
                style={{ width: "230px" }}
                iconClassName="wa"
                textField="name"
                dataItemKey="workTypeID"
                placeholder="Select Work Type"
                value={workType}
                onChange={onWorkTypeChange}
                disabled={!departmentID || loadingWorkTypes}
                loading={loadingWorkTypes}
              />
            </div>
            <Tooltip anchorElement="target" position="top">
              <FiAlertCircle
                title="Select Department to see corresponding work-types"
                className="mt-4 cursor-pointer"
                style={{ height: "20px", width: "20px" }}
              />
            </Tooltip>
          </div>

        </div>

        <Button
          className="common-btn setting-btn"
          onClick={() => {
            setAddnewform(true);
            props.open();
          }}
        >
          Add Activity<br />
          Tags
        </Button>
      </div>

      <div className="flex-grow-1 mb-2" style={{ minHeight: 0 }}>
        <ActivityTagsList
          departmentID={departmentID}
          workTypeID={workType?.workTypeID || 0}
        />
      </div>

      {addnewform && (
        <EditActivityTag
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
        />
      )}
    </div>
  );
};

export default ActivityTags;
